export default [
    {path: '/operations/:id/edit', screen: 'operation/EditOperation', secured: true, role: ['admin']},
    {path: '/operations/:id', screen: 'operation/DisplayOperation', secured: true, role: ['admin']},
    {path: '/operations', screen: 'operation/ListOperations', secured: true, role: ['admin']},
    {path: '/operation/new', screen: 'operation/CreateOperation', secured: true, role: ['admin']},
]